import { ReactNode } from "react";
import { Tabs } from "@mantine/core";
import { RowDataKPI, RowDataStaff } from "../../../../components/StaffPage/types";
import { props } from "../../../../components/StaffPage/props";
import { CustomTable } from "../../../../components/Table/CustomTable";
import { KPITypes } from "../../../DataDisplayTable/KPITable";
import TabI from "../../TabI";

export enum ColumnHeaderToFilterPairCurrent {
    STAFF_ID = "ID",
    TITLE = "Title",
    PERIOD = "Period",
    DURATION = "Duration",
    SCORE = "Score",
    TARGET = "Target"
}

export const colFilterCurrent = ColumnHeaderToFilterPairCurrent;
export const colFiltersCurrent: { [key in ColumnHeaderToFilterPairCurrent]: string } = {
    [colFilterCurrent.STAFF_ID]: "",
    [colFilterCurrent.TITLE]: "title",
    [colFilterCurrent.PERIOD]: "period",
    [colFilterCurrent.DURATION]: "duration",
    [colFilterCurrent.SCORE]: "score",
    [colFilterCurrent.TARGET]: "target",
};

class CurrentTab implements TabI {
    // sortBy: keyof RowDataStaff | null, setSorting: { (field: keyof RowDataStaff): void }, 
    // Th: { ({ children, sortable, reversed, sorted, onSort }: props): JSX.Element }, rowDataKPI: RowDataKPI[] | null, 
    sortBy: keyof RowDataStaff | null
    setSorting: { (field: keyof RowDataStaff): void }
    Th: { ({ children, sortable, reversed, sorted, onSort }: props): JSX.Element }
    rowDataKPI: RowDataKPI[] | null

    constructor(sortBy: keyof RowDataStaff | null, setSorting: { (field: keyof RowDataStaff): void }, Th: { ({ children, sortable, reversed, sorted, onSort }: props): JSX.Element }, rowDataKPI: RowDataKPI[] | null) {
        this.sortBy = sortBy
        this.setSorting = setSorting
        this.Th = Th
        this.rowDataKPI = rowDataKPI
    }

    create(reverseSortDirection: boolean, classes: { readonly [key: string]: string }, rows: JSX.Element[]): ReactNode {
        return (
            <Tabs.Panel value={KPITypes.CURRENT}>
                <CustomTable
                    colHeaders={Object.values(ColumnHeaderToFilterPairCurrent)}
                    filters={Object.values(colFiltersCurrent)}
                    reverseSortDirection={reverseSortDirection}
                    sortBy={this.sortBy}
                    setSorting={this.setSorting}
                    customclasses={classes}
                    Th={this.Th}
                    rowData={this.rowDataKPI}
                    rows={rows}
                />
            </Tabs.Panel>

        )
    }

}
export default CurrentTab